import React from 'react'
import { Form, Input, Select, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { RelativeDateDisplayMetric } from '@pushly/models/lib/enums/relative-date-display-metric'
import { MutableRelativeDate, RelativeDate } from '@pushly/models/lib/structs/relative-date'
import { calculateIntervalSecondsInputValue } from '@halo/portals/post-auth/domains/feeds/feed-data-form'

interface IFeedArticleAgeEditorProps {
    articleMaxAge: RelativeDate
    articleAgeInputValue?: number
    onChange(articleMaxAge: RelativeDate, frequencyValue?: number): void
}

export const FeedArticleAgeEditor = ({ articleMaxAge, articleAgeInputValue, onChange }: IFeedArticleAgeEditorProps) => {
    return (
        <>
            <Form.Item
                label={
                    <div className="article-constraints-input-label">
                        Article Age
                        <Tooltip title="The maximum age an article can be to be eligible for this feed.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </div>
                }
                className="article-age"
            >
                <Input
                    className="article-age-input"
                    size="small"
                    maxLength={4}
                    value={articleAgeInputValue}
                    onChange={(ev) => {
                        const raw = ev.target.value.trim()
                        const frequencyValue = !raw || isNaN(raw as any) ? 0 : parseInt(raw, 10)
                        const displayMetric = articleMaxAge.displayMetric ?? RelativeDateDisplayMetric.DAYS
                        const intervalSeconds = calculateIntervalSecondsInputValue(frequencyValue, displayMetric)

                        const nextArticleMaxAge = new MutableRelativeDate()
                        nextArticleMaxAge.intervalSeconds = intervalSeconds
                        nextArticleMaxAge.displayMetric = displayMetric

                        onChange(nextArticleMaxAge, frequencyValue)
                    }}
                    addonAfter={
                        <Select<RelativeDateDisplayMetric>
                            size="small"
                            value={articleMaxAge.displayMetric ?? RelativeDateDisplayMetric.DAYS}
                            onChange={(metric) => {
                                const nextArticleMaxAge = new MutableRelativeDate()
                                nextArticleMaxAge.intervalSeconds = calculateIntervalSecondsInputValue(
                                    articleAgeInputValue,
                                    metric,
                                )
                                nextArticleMaxAge.displayMetric = metric

                                onChange(nextArticleMaxAge)
                            }}
                        >
                            <Select.Option value={RelativeDateDisplayMetric.HOURS}>Hours</Select.Option>
                            <Select.Option value={RelativeDateDisplayMetric.DAYS}>Days</Select.Option>
                            <Select.Option value={RelativeDateDisplayMetric.MONTHS}>Months</Select.Option>
                        </Select>
                    }
                />
            </Form.Item>
        </>
    )
}
